import React from 'react';
import {
  AfterSubmitFunc,
  Button,
  ButtonColor,
  FormTemplate,
  useShowContextRequired,
  Wysiwyg
} from 'ui-builder';
import { MarketRequest, UpdateRequestRequest, useMarketRequestsAdminService } from 'nekst-api';
import { MarketRequestStatusDropdown } from './MarketRequestStatusDropdown';
import { usePopupFormManager } from 'features/nekst-widgets';
import { parseSetupAreaIdWithVersion, SetupAreaAndVersionDropdown } from 'features/tasks-forms';

export function UpdateRequestForm(
  props: {
    data: MarketRequest,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const marketRequestsAdminService = useMarketRequestsAdminService();

  return (
    <FormTemplate<UpdateRequestRequest & { setupAreaIdWithVersion?: string }>
      title={`Update Request: "${props.data.name}"`}
      submitFormFunc={async (data) => {

        if (data.setupAreaIdWithVersion) {
          const {
            setupAreaId,
            setupAreaVersion
          } = parseSetupAreaIdWithVersion(data.setupAreaIdWithVersion);

          data.setupAreaId = setupAreaId;
          data.setupAreaVersion = setupAreaVersion;
        }

        await marketRequestsAdminService.updateMarketRequest(
          props.data.id,
          data
        );

        return data;
      }}
      initialData={{
        status: props.data.status,
        resultDescription: props.data.resultDescription,
        setupAreaIdWithVersion: props.data._setupArea ? `${props.data._setupArea.id}:${props.data._setupArea.version}` : undefined
      }}
      afterSubmitFunc={props.afterSubmitFunc}
      validationSchema={{
        status: {
          type: 'string',
          constraints: {
            required: true
          }
        }
      }}
    >
      <MarketRequestStatusDropdown />
      <Wysiwyg source="resultDescription" label="Response To the User" />
      <SetupAreaAndVersionDropdown
        source="setupAreaIdWithVersion"
        label="Market"
        hint="If a market was created based on this request, please select it here."
      />
    </FormTemplate>
  );
}

export function UpdateMarketRequestButton() {
  const popupFormManager = usePopupFormManager();

  const { data } = useShowContextRequired<MarketRequest>();

  return (
    <Button
      text="Update"
      isFilled
      color={ButtonColor.BLUE}
      onClick={async () => {
        popupFormManager.openForm(<UpdateRequestForm data={data} />);
      }}
    />
  );
}
